import React from 'react';

const noop = () => {};

export interface Context {
  /**
   * Add an item to the form passing in the initial state
   */
  register: (isValid?: boolean) => string;
  /**
   * Remove registration of the identifier from the form
   */
  deregister: (identifier: string) => void;
  /**
   * Update the form state for the identifier
   */
  update: (identifier: string, isValid?: boolean) => void;
  /**
   * Returns whether the form is currently considered to be valid
   */
  getIsValid: () => boolean;
}

const ValidationContext = React.createContext<Context>({
  register: () => '',
  deregister: noop,
  update: noop,
  getIsValid: () => false
});

export default ValidationContext;
